module.exports = __webpack_public_path__ + "static/assets/f3b2cad0964d89b89567d5affd3b8928.gif";